import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { approvedBadgeIcon } from '@ld.consumer-portal/data-uri';
import { SvgIconComponent } from '@ld.consumer-portal/ui-shared';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

export type CelebrationType = 'all-todos-complete' | 'conditional-approval';

@Component({
  selector: 'ld-congratulations-modal',
  imports: [BaseModalComponent, SvgIconComponent, TranslocoDirective],
  templateUrl: './congratulations-modal.component.html',
  styleUrl: './congratulations-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CongratulationsModalComponent {
  protected readonly approvedBadgeIcon = approvedBadgeIcon;

  private readonly transloco = inject(TranslocoService);

  readonly celebrationType = input<CelebrationType>('all-todos-complete');

  readonly titleOverride = input<string | undefined>(undefined, { alias: 'title' });

  readonly messageOverride = input<string | undefined>(undefined, { alias: 'message' });

  readonly buttonText = input<string>(this.transloco.translate('commonButtonsContinue'));

  protected readonly displayTitle = computed(() => {
    const override = this.titleOverride();
    if (override) return override;

    return this.celebrationType() === 'conditional-approval'
      ? this.transloco.translate('commonLabelsCongratulations')
      : this.transloco.translate('commonLabelsCongratulations');
  });

  protected readonly displayMessage = computed(() => {
    const override = this.messageOverride();
    if (override) return override;

    return this.celebrationType() === 'conditional-approval'
      ? this.transloco.translate('originationDashboardConditionalApprovalMessage')
      : this.transloco.translate('modalsCongratulationsMessage');
  });

  readonly close = output<void>();

  protected onClose(): void {
    this.close.emit();
  }

  protected onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.close.emit();
    }
  }
}
